import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const RenderSingle = props => {
    const content = ReactHtmlParser(props.posts.posts[0].content.rendered);

    const ShowContent = () => (
        <section className="inner-container">
            <div className="entry-content">{content}</div>
        </section>
    );

    return <ShowContent />;
};

export default RenderSingle;



// WEBPACK FOOTER //
// ./src/components/Pages/RenderSingleFriendly.jsx